import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

/**
 * Adds the saved access token to API requests and clears an invalid session.
 * The token is deliberately not added to the OTP/register endpoints because
 * those endpoints establish the session rather than consume it.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.getToken();
  const isAuthRequest =
    /\/api\/tenants\/v1\/emp\/web\/(?:login\/)?otp(?:\/|$)|\/api\/tenants\/v1\/emp\/web\/register(?:\/|$)/.test(
      req.url,
    );
  const wordpressBaseUrl = environment.api.wordpressBaseUrl.replace(/\/+$/, '');
  const isWordpressRequest =
    req.url === wordpressBaseUrl || req.url.startsWith(`${wordpressBaseUrl}/`);

  const authReq =
    token && !isAuthRequest && !isWordpressRequest
      ? req.clone({ setHeaders: { Authorization: token } })
      : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !isAuthRequest && !isWordpressRequest) {
        authService.clearToken();
        void router.navigate(['/login'], {
          queryParams: { reason: 'session-expired' },
        });
      }

      return throwError(() => error);
    }),
  );
};
